exports.DRIVER = {
  DELIVERED_WITH_CARE: "DWC",
  WENT_EXTRA_MILE: "WEM",
  FRIENDLY_MANNER: "FRM",
  RESPECTED_MY_PROPERTY: "RMP",
  DRIVER_WAS_RUDE: "DWR",
  NOT_DELIVERED_CAREFULLY: "NDC",
  NOT_FOLLOW_INSTRUCTIONS: "DNI",
  NOT_SET: "NOS",
};

exports.DELIVERY = {
  DELIVERED_ON_TIME: "DOT",
  KEPT_ME_INFORMED: "KMI",
  FOLLOWED_MY_INSTRUCTIONS: "FMI",
  HAVE_NOT_GOT_MY_PARCEL: "DNG", // need approval
  BAD_EXPERIENCE: "BE", // need approval
  DELIVERY_COMPLAINTS: "DC", // need approval
  DELIVERED_TO_WRONG_PLACE: "DWP", // need approval
  NOT_SET: "NOS", // passed by page if nothing set
  NOT_AVAILABLE: "NA", // not available if consumer blank
  UNKNOWN: "UNK", // default if consumer set
};
